import { createStyles, makeStyles } from "@material-ui/core/styles";
import { WHITE, DARK_GREY, ALMOST_WHITE, ACCENT_BLUE, BLACK } from "constants/colors";

export const useStyles = makeStyles(() =>
createStyles({
    root: {
      width: '100%',
      background:"transparent !important",
      color:"white",
      boxSizing:"border-box",
        "& .MuiStepIcon-active": { color: "#90caf9" },
        "& .MuiStepIcon-completed": { color: "#8a9199" },
        "& .Mui-disabled .MuiStepIcon-root": { color: "#8a9199" },
        "& .MuiStepIcon-text":{fill:"black",fontWeight:"bold"},
        "& .MuiStepLabel-label":{color:"grey"},
        "& .MuiStepLabel-active":{color:"white !important"},
        "& .MuiStepLabel-completed":{color:"white"},
        "& .MuiAutocomplete-clearIndicator":{color:"white !important"},
        "& .MuiAutocomplete-input":{color:"white !important"},  
        "& .Mui-checked":{
          color: "#90caf9"
        },
        "& .Mui-disabled":{
          color:"#757b86 !important"
        },
        "& .MuiChip-sizeSmall ":{
          backgroundColor: "#5c6166 !important",
          color: "white !important"
        },
        "& .MuiChip-deleteIconSmall":{
          color:"#8a9199"
        },
        "& .MuiAutocomplete-tag":{
          backgroundColor:"transparent"
        },
        "& #buscar":{
          height:"36px",
        },
            '& input[type="text"]::-ms-clear': {
          display: "none !important",
          height: "0 !important",
          width: "0 !important"
        }, 

    },
    button: {
      height: "auto",
      padding: "8px 16px",
      marginLeft: 8,
      backgroundColor: "#363d47",
      border:"none",
      borderRadius: "32px",
      cursor: "pointer",
      outline: "none",
      flexDirection: "row",
      alignItems: "center",
      color: WHITE,
      fontWeight:"bold",
      "&:hover,&:focus": {
        color: BLACK,
        backgroundColor: "#90caf9",
        border:"none"
      },
      "& > span > span": {
        fontStyle: "normal",
        fontSize: 14,
        lineHeight: "19px",
        fontWeight: 600,

      },
    },



    disabledButton:{
      height: "auto",
      padding: "8px 16px",
      marginLeft: 8,
      backgroundColor: "#363d47",
      border:"none",
      borderRadius: "32px",
      cursor: "pointer",
      outline: "none",
      flexDirection: "row",
      alignItems: "center",
      color:WHITE,
      fontWeight:"bold",
     opacity:0.5,
      "& > span > span": {
        color: WHITE,
        fontStyle: "normal",
        fontSize: 14,
        lineHeight: "19px",
        fontWeight: 600,

      },

    },

    backButton:{
      height: "auto",
      padding: "8px 16px",
      marginLeft: 8,
      backgroundColor: "transparent",
      border:"none",
      borderRadius: "32px",
      cursor: "pointer",
      outline: "none",
      flexDirection: "row",
      alignItems: "center",
      color: "#CFD9E6",
      fontWeight:"bold",
      "&:hover,&:focus": {
        backgroundColor: "#363d47",
        border:"none"
      },
      "& > span > span": {
        fontStyle: "normal",
        fontSize: 14,
        lineHeight: "19px",
        fontWeight: 600,

      },
     
    },
    actionsContainer: {
      marginTop: "10px",
    },
    resetContainer: {
      padding: "30px",
    },
    moveCardTitle: {
        fontFamily: "Roboto",
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "14px",
        lineHeight: "16px",
        color: "#C6D1E0",
        margin:"20px 30px 5px 30px"
    },
    dropdownLabel: {
      backgroundColor: "#363D47",
      borderRadius: "4px",
      fontSize: "14px",
      width:"100%"
    },
    labelItem: {
      fontSize: "14px !important",
      minHeight:"30px !important"
    },
    select: {
      color: WHITE,
      zIndex: 100,
      '&::after': {
        borderBottom: '2px solid #90caf9'
      },
      '&::before': {
        borderBottom: '2px solid #596c8d'
      },
      '&:hover:not($disabled):before': {
        borderBottom: '2px solid #90caf9'

      },
      "& .MuiSvgIcon-root": {
        color: WHITE,
      },
    },
   searchInstrumentBox:{
      display:"flex",
      width:"100%",
      backgroundColor:"#363D47",
      padding:"0px 10px",
      color: "#FFFFFF",
      boxSizing:"border-box",
      borderRadius:"4px",
      alignItems:"center"

    },
    searchDropdownLabel: {
      backgroundColor: "#363D47",
      borderRadius: "4px",
      fontSize: "14px",
      padding:"0px !important",
      color:"white !important",
      margin:"5px !important"
    },

    searchInstrumentIcon:{
      width:"10%",
      color:'white !important'
    },

    searchInstrument:{

    },

    input:{
      color:"white",
      padding:"0px"
    },
    option: {
        backgroundColor: "#535454 !important",
        color:"white",
        fontWeight:"normal",
        padding:0    
    },
    chip:{
      backgroundColor: "#5c6166 !important",
      color: "white !important"
    },

    columnTitle: {
      backgroundColor: "#171a1f",
      color: "white",
    },
    columnDescName: {
      fontSize: "14px",
      overflow: "auto",
      height: "220px",
      gridGap: "10px",
      width: "100%",
    },

    SubcolumnDescName:{
      fontSize: "14px",         
    },
    searchBox:{
      display:"flex",
      width:"100%",
      backgroundColor:"#363D47",
      padding:"7px 10px",
      color: "#FFFFFF",
      boxSizing:"border-box",
      borderRadius:"4px"
    },

    searchIcon: {
      margin:"5px",
      color: "rgb(118, 118, 118)",
    },

    search: {
      width: "100%",
      backgroundColor: "#363D47",
      outline: "0",
      border: "0px",
      boxSizing: "border-box",
      fontSize: "14px !important",
      color: "#FFFFFF",
      borderRadius: "4px",
      "&::-ms-clear": {
        display: "none",
        height: "0 !important",
        width: "0 !important"
      },
      "&::-webkit-search-decoration,::-webkit-search-cancel-button,::-webkit-search-results-button,::-webkit-search-results-decoration":{
        display:"none"
      }
    },


    highlightText:{
      color:"#90caf9"
    },
    datePicker:{
      width:"80%",
      backgroundColor:"#363D47",
      color:"white !important",
      border: "none",
      outline: "none",
      padding: "5px 10px !important",
      borderRadius: "5px",
      colorScheme: "dark",
      margin:"0px 5px"
    },

    checkBoxLabel:{
      color:WHITE,
    },
    checkBoxGridLabel:{
      marginRight:"0px !important",
      color:WHITE,
    },

    checkbox:{
      color: "white",
    },


    renderDiv:{
      display:"flex",
      justifyContent:"space-between",
      width:"90%"
    },

    leftRenderDiv:{
      width:"70%"
    },

    rightRenderDiv:{
      color:"grey",
      fontWeight:"bold"
    },
    
    dragContent:{
      display:"flex",
      alignItems:"center"
    },

    dragListContainer:{
      width: "100%",
      overflow: "auto",
      maxHeight: "190px",
      padding: 0,
      height: "100%"
    },

    dragIcon:{
      fontSize:"20px",
      color:"#90caf9",
      margin:"0px 5px"
    },

    diableDragbIcon:{
      fontSize:"20px",
      color:"grey",
      margin:"0px 5px"
    },
    classLabel:{
      color: '#CFD9E6',
      "&.Mui-focused": {
       color: "#CFD9E6"
     }
    },
    ccssLabel: {
      color: '#CFD9E6',
    },
    cssFocused: {
      color: '#CFD9E6 !important'
    },
    cssOutlinedInput: {
      color: "white",
      outline: "0px",
      '&::after': {
        borderBottom: '2px solid #90caf9'
      },
      '&::before': {
        borderBottom: '2px solid #596c8d'
      },
      '&:hover:not($disabled):before': {
        borderBottom: '2px solid #90caf9 !important'  

      },
    },

  })
);

